export const splitFullName = (fullName: string) => {
  const parts = fullName.trim().split(/\s+/)

  let first_name: string | undefined = undefined
  let middle_name: string | undefined = undefined
  let last_name: string | undefined = undefined

  if (parts.length === 1) {
    first_name = parts[0]
  } else if (parts.length === 2) {
    first_name = parts[0]
    last_name = parts[1]
  } else if (parts.length > 2) {
    first_name = parts[0]
    middle_name = parts.slice(1, -1).join(' ')
    last_name = parts[parts.length - 1]
  }

  return {
    full_name: fullName,
    ...(first_name && { first_name }),
    ...(middle_name && { middle_name }),
    ...(last_name && { last_name }),
  }
}
